import { Link } from 'react-router-dom';

function Breadcrumbs({ breadcrumbs }) {
    if (!breadcrumbs || breadcrumbs.length <= 1) return null;

    return (
        <nav className="breadcrumbs">
            {breadcrumbs.map((crumb, idx) => {
                const path = new URL(crumb.url).pathname;
                const isLast = idx === breadcrumbs.length - 1;
                const isMobileHidden = idx < breadcrumbs.length - 2;
                return (
                    <span key={idx} className={isMobileHidden ? 'breadcrumb-hidden-mobile' : ''}>
                        {idx > 0 && <span className="breadcrumb-sep">›</span>}
                        {isLast
                            ? <span className="breadcrumb-current">{crumb.name}</span>
                            : <Link to={path}>{crumb.name}</Link>
                        }
                    </span>
                );
            })}
        </nav>
    );
}

export default Breadcrumbs;
